import React from "react";

export const CartProductQuantity = ({ item, settings }) => {
  const { routes } = settings;

  const LayoutComponent: any = 'ajax-cart-quantity';

  return (
    <div className="cart-product-quantity flex items-start">
      <div className="flex flex-auto w-full">
        <div className="flex w-full items-center justify-between">
          {<LayoutComponent className="flex flex-auto">
            <div className="quantity flex max-h-[36px] lg:max-h-[40px] w-[120px] lg:w-[140px] items-center justify-between text-center border border-black py-[6px] px-3 lg:py-2 lg:px-3 rounded-full">
            <button
                    data-ajax-cart-quantity-minus
                    className="flex items-center w-auto h-auto p-1 border-none"
                  >
                    <span className="icon-minus text-[24px]"></span>
                  </button>
              <input
                type="number"
                value={`${item.quantity}`}
                name="updates[]"
                data-ajax-cart-quantity-input={`${item.key}`}
                style={{
                  width: "36px",
                  paddingBottom: "0px",
                }}
                className="noscroll border-none text-center outline-none focus:border-none !text-[14px] border-white  focus:outline-none active:outline-none "
                readOnly={true}
              />
               <button
                    data-ajax-cart-quantity-plus
                    className="flex items-center w-auto h-auto p-1 border-none"
                  >
                    <span className="icon-plus text-[24px]"></span>
                  </button>
            </div>
          </LayoutComponent>}

          {/* <div
              data-ajax-cart-request-button={`/cart/change?id=${item.key}&quantity=0`}
              className="cursor-pointer p-[5px]"
          >
            <i className="icon icon-x-thin lg:text-xl"></i>
          </div> */}
        </div>
      </div>
    </div>
  );
};
